<!-- 首页-行业解决方案（PC / 手机端均为手风琴；手机端可横向滑动） -->
<template>
	<div class="IndustrySolutions-warp">
		<div class="title">
			<span class="title-text">行业解决方案</span>
		</div>

		<div
			class="solution-accordion"
			:class="{ 'is-mobile': isMobileEnd }"
			ref="accordion"
		>
			<div
				class="solution-card"
				v-for="(item, index) in cardList"
				:key="item.id"
				:class="{ 'is-active': activeIndex === index }"
				@mouseenter="handleCardEnter(index)"
				@click="handleMobileExpand(index)"
			>
				<div class="card-bg" :style="bgStyle(item.coverImg)"></div>
				<div class="card-mask"></div>
				<div class="card-content">
					<div class="card-name">{{ item.name }}</div>
					<ul class="card-features">
						<li
							v-for="(feat, i) in item.features"
							:key="feat.id || i"
							@click.stop="handleSolution(feat.id)"
						>
							<span class="feat-dot">·</span>
							<span class="feat-text">{{ feat.name }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getHomeFieldList, getHomePlanList } from '@/network/home/index'
import { getSolutionDetails } from '@/network/solution/index'

export default {
	name: 'IndustrySolutions',
	data() {
		return {
			/** @type {{ id: number, name: string, coverImg: string, features: { id: number, name: string }[], priority: number }[]} */
			cardList: [],
			activeIndex: 0,
		}
	},
	computed: {
		isMobileEnd() {
			return this.$store.state.isMobileEnd
		},
	},
	watch: {
		activeIndex() {
			if (this.isMobileEnd) {
				this.$nextTick(() => this._scrollActiveIntoView())
			}
		},
	},
	created() {
		this._loadPlanCards()
	},
	methods: {
		bgStyle(coverImg) {
			if (!coverImg) return {}
			return { backgroundImage: `url(${coverImg})` }
		},
		_resolveImg(path) {
			if (!path) return ''
			if (
				/^https?:\/\//.test(path) ||
				/^data:/.test(path) ||
				path.startsWith('/')
			) {
				return path
			}
			return window.baseUrl + path
		},
		handleCardEnter(index) {
			if (this.isMobileEnd) return
			this.activeIndex = index
		},
		/** 手机端：点击卡片仅用于展开，不跳转详情 */
		handleMobileExpand(index) {
			if (!this.isMobileEnd) return
			this.activeIndex = index
		},
		handleSolution(id) {
			if (!id) return
			this.$router.push({
				path: '/solution',
				query: { id },
			})
		},
		_scrollActiveIntoView() {
			const wrap = this.$refs.accordion
			if (!wrap) return
			const card = wrap.children[this.activeIndex]
			if (!card) return
			const cardLeft = card.offsetLeft
			const cardWidth = card.offsetWidth
			const wrapWidth = wrap.clientWidth
			const target = cardLeft - (wrapWidth - cardWidth) / 2
			wrap.scrollTo({
				left: Math.max(0, target),
				behavior: 'smooth',
			})
		},
		/**
		 * 按领域聚合：card-name = 领域名称，feat = 该领域下方案名称
		 * 接口：/plan/field、/plan/list?fieldId=
		 */
		async _loadPlanCards() {
			try {
				const fieldRes = await getHomeFieldList()
				if (fieldRes.data.code != 200) return

				const fields = (fieldRes.data.data.list || [])
					.filter((f) => f.visible !== false)
					.sort(
						(a, b) =>
							(a.priority != null ? a.priority : 999) -
							(b.priority != null ? b.priority : 999)
					)
					.slice(0, 6)

				const planResults = await Promise.all(
					fields.map((f) => getHomePlanList(f.id))
				)

				this.cardList = await Promise.all(
					fields.map(async (field, i) => {
						const res = planResults[i]
						let plans = []
						if (res && res.data.code == 200) {
							plans = (
								(res.data.data && res.data.data.list) ||
								[]
							)
								.filter((p) => p.visible !== false)
								.sort(
									(a, b) =>
										(a.priority != null
											? a.priority
											: 999) -
										(b.priority != null ? b.priority : 999)
								)
						}

						let coverImg = this._resolveImg(
							field.banner || field.coverImg || field.img || ''
						)
						if (!coverImg && plans[0] && plans[0].id) {
							coverImg = await this._fetchPlanCover(plans[0].id)
						}

						return {
							id: field.id,
							name: field.name || field.fieldName || '',
							coverImg,
							features: plans
								.map((p) => ({
									id: p.id,
									name: p.name || '',
								}))
								.filter((p) => p.name),
							priority: field.priority,
						}
					})
				)
				this.activeIndex = 0
			} catch (error) {
				console.error('获取解决方案卡片失败', error)
			}
		},
		async _fetchPlanCover(id) {
			try {
				const res = await getSolutionDetails(id)
				if (res.data.code != 200 || !res.data.data) return ''
				return this._resolveImg(res.data.data.banner)
			} catch (error) {
				console.error('获取方案封面失败', id, error)
				return ''
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.IndustrySolutions-warp {
	position: relative;
	margin-bottom: 80px;
	/* 底色/圆环底图由 Home.home-tech-solution 统一提供 */
	background-color: transparent;
	box-sizing: border-box;
}

.title {
	position: relative;
	z-index: 1;
	width: 100%;
	margin-bottom: 48px;
	text-align: center;
	.title-text {
		font-size: 36px;
		font-weight: 500;
		color: #333333;
		line-height: 52px;
		display: block;
	}
}

/* 1920：默认 195×430，hover 262×430 */
.solution-accordion {
	position: relative;
	z-index: 1;
	--card-w: 195px;
	--card-w-active: 262px;
	--card-h: 430px;
	--card-gap: 12px;
	--active-blur: 16px;

	width: max-content;
	max-width: calc(100% - 48px);
	margin: 0 auto;
	display: flex;
	align-items: stretch;
	justify-content: center;
	gap: var(--card-gap);
	height: var(--card-h);
	overflow-x: auto;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: thin;

	&::-webkit-scrollbar {
		height: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.2);
		border-radius: 2px;
	}
}

.solution-card {
	position: relative;
	width: var(--card-w);
	flex: 0 0 var(--card-w);
	height: 100%;
	border-radius: 16px;
	overflow: hidden;
	cursor: default;
	transition: width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
		flex-basis 0.45s cubic-bezier(0.4, 0, 0.2, 1);

	.card-bg {
		position: absolute;
		top: -24px;
		right: -24px;
		bottom: -24px;
		left: -24px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		transform: scale(1.05);
		filter: blur(0);
		transition: filter 0.45s ease, transform 0.45s ease;
		will-change: filter, transform;
	}

	.card-mask {
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.45);
		z-index: 1;
	}

	.card-content {
		position: relative;
		z-index: 2;
		height: 100%;
		padding: 63px 41px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #ffffff;
	}

	.card-name {
		font-size: 28px;
		font-weight: 500;
		line-height: 40px;
		text-align: center;
		white-space: nowrap;
		text-shadow: 0 1px 8px rgba(0, 0, 0, 0.35);
		transition: font-size 0.35s ease, text-align 0.35s ease;
	}

	.card-features {
		list-style: none;
		margin: 20px 0 0;
		padding: 0;
		width: 100%;
		opacity: 0;
		visibility: hidden;
		transform: translateY(8px);
		pointer-events: none;
		text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
		transition: opacity 0.35s ease 0.08s, transform 0.35s ease 0.08s,
			visibility 0.35s;

		li {
			display: flex;
			align-items: flex-start;
			margin-bottom: 10px;
			color: #d6d7db;
			font-size: 14px;
			line-height: 22px;
			font-weight: 400;
			cursor: pointer;
			transition: color 0.2s ease;

			&:last-child {
				margin-bottom: 0;
			}

			&:hover {
				color: #1b6fff;
			}
		}

		.feat-dot {
			flex-shrink: 0;
			width: 14px;
			margin-right: 2px;
			line-height: 22px;
		}

		.feat-text {
			word-break: break-all;
		}
	}

	&.is-active {
		width: var(--card-w-active);
		flex-basis: var(--card-w-active);

		.card-bg {
			filter: blur(var(--active-blur));
			transform: scale(1.18);
		}

		.card-content {
			align-items: flex-start;
			padding: 30px;
		}

		.card-name {
			font-size: 28px;
			font-weight: 500;
			line-height: 40px;
			text-align: left;
			white-space: normal;
		}

		.card-features {
			opacity: 1;
			visibility: visible;
			transform: translateY(0);
			pointer-events: auto;
		}
	}
}

/* 手机端：同款手风琴，横向滑动查看 */
@media screen and (max-width: 768px) {
	.IndustrySolutions-warp {
		background-color: transparent;
		margin-bottom: 32px;
		padding: 0 0 8px;
		.title {
			margin-bottom: 24px;
			.title-text {
				height: 24px;
				font-weight: 500;
				font-size: 24px;
				color: #333333;
				line-height: 24px;
			}
		}
	}

	.solution-accordion {
		--card-w: 120px;
		--card-w-active: 200px;
		--card-h: 280px;
		--card-gap: 10px;
		--active-blur: 10px;

		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
		padding: 0 12px;
		justify-content: flex-start;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.solution-card {
		border-radius: 8px;

		.card-content {
			padding: 30px 24px;
			border-radius: 8px;
		}

		.card-name {
			font-size: 18px;
			line-height: 20px;
		}

		.card-features {
			margin-top: 12px;

			li {
				color: #d6d7db;
				line-height: 18px;
				margin-bottom: 6px;
			}
		}

		&.is-active {
			.card-content {
				padding: 30px 24px;
			}

			.card-name {
				font-size: 22px;
				line-height: 26px;
			}
		}
	}
}
</style>
